var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1682",
    "data-name": "Group 1682",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 54,
    height: 36,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1684",
    "data-name": "Group 1684",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M49.5,36H4.5A4.5,4.5,0,0,1,0,31.5V4.5A4.5,4.5,0,0,1,4.5,0h45A4.5,4.5,0,0,1,54,4.5v27A4.5,4.5,0,0,1,49.5,36",
    fill: "#45486b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M11.309,17.52H6.129A1.435,1.435,0,0,1,4.7,16.085V12.646a1.435,1.435,0,0,1,1.434-1.434h5.18a1.435,1.435,0,0,1,1.434,1.434v3.439a1.443,1.443,0,0,1-1.434,1.435",
    fill: "#424566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M11.309,17.425H6.119a1.342,1.342,0,0,1-1.34-1.34V12.636a1.342,1.342,0,0,1,1.34-1.34h5.19a1.342,1.342,0,0,1,1.34,1.34v3.449a1.342,1.342,0,0,1-1.34,1.34",
    fill: "#febd55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M12.648,14.471V14.26H9.9v-.928l.707-.707h2.036a1.257,1.257,0,0,0-.021-.211H10.56a.1.1,0,0,0-.074.032l-.739.738H8.819V11.307H8.608v1.877H7.69l-.738-.738a.115.115,0,0,0-.074-.032H4.8a1.257,1.257,0,0,0-.021.211H6.836l.7.7v.938H4.779v.211H7.532v.939l-.7.7H4.779a1.246,1.246,0,0,0,.021.211H6.878a.1.1,0,0,0,.074-.031l.738-.739h.918v1.878h.211V15.547h.928l.739.739a.1.1,0,0,0,.073.031h2.068a1.246,1.246,0,0,0,.021-.211H10.612L9.9,15.4v-.929Zm-2.954.865H7.742V13.384H9.694Z",
    fill: "#b5613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M48.356,12.362a.291.291,0,0,1-.137-.032.3.3,0,0,1-.137-.422,5.589,5.589,0,0,0,0-5.074.314.314,0,0,1,.559-.285,6.194,6.194,0,0,1,0,5.644.335.335,0,0,1-.285.169m-1.087-.6a4.791,4.791,0,0,0,0-4.789.317.317,0,1,0-.548.317,4.143,4.143,0,0,1,0,4.166.323.323,0,0,0,.116.433.293.293,0,0,0,.158.042.382.382,0,0,0,.274-.169m-1.35-.422a3.426,3.426,0,0,0,0-3.945.319.319,0,0,0-.527.359,2.826,2.826,0,0,1,0,3.228.321.321,0,0,0,.084.443.278.278,0,0,0,.179.053A.328.328,0,0,0,45.919,11.338Zm-1.424-.411a2.058,2.058,0,0,0,0-3.122.314.314,0,1,0-.422.464,1.442,1.442,0,0,1,0,2.194.315.315,0,0,0-.021.443.34.34,0,0,0,.232.1A.332.332,0,0,0,44.495,10.927Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M26.573,31.033H5.095a.317.317,0,0,1,0-.633H26.573a.311.311,0,0,1,.316.317.317.317,0,0,1-.316.316",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M49,31.033H44.928a.316.316,0,1,1,0-.632H49a.31.31,0,0,1,.316.316.317.317,0,0,1-.316.316m-5.8-.316a.31.31,0,0,0-.316-.316H38.81a.316.316,0,1,0,0,.632h4.072a.317.317,0,0,0,.316-.316",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M5.1,6.844a.311.311,0,0,1-.317-.316V5.294a.317.317,0,1,1,.633,0V6.528a.317.317,0,0,1-.316.316m2.035-.316V5.294a.316.316,0,1,0-.632,0V6.528a.31.31,0,0,0,.316.316.317.317,0,0,0,.316-.316m1.731,0V5.294a.317.317,0,1,0-.633,0V6.528a.31.31,0,0,0,.316.316.324.324,0,0,0,.317-.316m1.719,0V5.294a.317.317,0,1,0-.633,0V6.528a.311.311,0,0,0,.317.316.317.317,0,0,0,.316-.316",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M5.749,25.664H5.7a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.957.957,0,0,1-.96.96M5.7,22.879a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M8.313,25.664H8.26a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.957.957,0,0,1-.96.96M8.26,22.879a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053A.329.329,0,0,0,8.64,24.7v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M10.876,25.664h-.053a.964.964,0,0,1-.96-.96v-1.5a.964.964,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053A.329.329,0,0,0,11.2,24.7v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M13.44,25.664h-.053a.964.964,0,0,1-.96-.96v-1.5a.964.964,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M17.374,25.664h-.053a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053A.329.329,0,0,0,17.7,24.7v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M19.938,25.664h-.053a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M22.5,25.664h-.053a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96H22.5a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327H22.5a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M25.064,25.664h-.053a.963.963,0,0,1-.959-.96v-1.5a.963.963,0,0,1,.959-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M29,25.664h-.053a.964.964,0,0,1-.96-.96v-1.5a.964.964,0,0,1,.96-.96H29a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327H29a.329.329,0,0,0,.327-.327v-1.5A.329.329,0,0,0,29,22.879Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M31.563,25.664H31.51a.964.964,0,0,1-.96-.96v-1.5a.964.964,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M34.126,25.664h-.053a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M36.69,25.664h-.053a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.33.33,0,0,0,.327-.327v-1.5a.33.33,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M40.624,25.664h-.053a.964.964,0,0,1-.96-.96v-1.5a.964.964,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M43.188,25.664h-.053a.964.964,0,0,1-.96-.96v-1.5a.964.964,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M45.751,25.664H45.7a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96M45.7,22.879a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M48.314,25.664h-.053a.963.963,0,0,1-.96-.96v-1.5a.963.963,0,0,1,.96-.96h.053a.964.964,0,0,1,.96.96v1.5a.964.964,0,0,1-.96.96m-.053-2.785a.329.329,0,0,0-.327.327v1.5a.329.329,0,0,0,.327.327h.053a.329.329,0,0,0,.327-.327v-1.5a.329.329,0,0,0-.327-.327Z",
    fill: "#757bb5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard);
export default __webpack_public_path__ + "static/media/icon-credit-card.ba59fb691aa00c2062b26c7d6e6043d0.svg";
export { ForwardRef as ReactComponent };